// Клавиатура для нового чата (В3, 1.27.3).
//
// iOS открывает клавиатуру только на фокус внутри жеста. Новый чат создаётся запросом,
// и поле ввода появляется уже после него — фокус оттуда клавиатуру не открывал, и
// человек тапал в поле ещё раз. Поэтому в самом тапе фокусируем невидимое поле-заглушку
// (клавиатура выезжает сразу), а экран чата переносит фокус в композер: перенос фокуса
// при уже открытой клавиатуре iOS разрешает. Не дождались экрана — заглушка убирается.

const PROXY_LIFETIME_MS = 5000;

let proxy = null;
let proxyTimer = null;

export function primeKeyboard() {
  if (typeof document === 'undefined') {
    return;
  }
  releaseKeyboard();
  const input = document.createElement('input');
  input.type = 'text';
  input.tabIndex = -1;
  input.setAttribute('aria-hidden', 'true');
  input.setAttribute('autocomplete', 'off');
  // 16px — иначе iOS увеличивает страницу при фокусе.
  input.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;border:0;padding:0;font-size:16px;';
  document.body.appendChild(input);
  input.focus({ preventScroll: true });
  proxy = input;
  proxyTimer = setTimeout(releaseKeyboard, PROXY_LIFETIME_MS);
}

export function hasPrimedKeyboard() {
  return proxy !== null;
}

// Экран чата: забрать фокус у заглушки в своё поле. true — клавиатура уже была открыта.
export function handOffKeyboard(target) {
  if (!proxy) {
    return false;
  }
  target?.focus?.({ preventScroll: true });
  releaseKeyboard();
  return true;
}

export function releaseKeyboard() {
  if (proxyTimer) {
    clearTimeout(proxyTimer);
    proxyTimer = null;
  }
  if (!proxy) {
    return;
  }
  const input = proxy;
  proxy = null;
  if (document.activeElement === input) {
    input.blur();
  }
  input.remove();
}
